import React from "react";
import { sliceString } from "../../theme/helpers";
import { Tools, CardCover, Content, Title, Description } from "./CardTools.styled";

var CardTools = function CardTools(_a) {
  var title = _a.title,
      description = _a.description,
      url = _a.url,
      icon = _a.icon;
  return React.createElement(Tools, {
    to: url
  }, React.createElement(CardCover, null, icon ? React.createElement("img", {
    src: icon,
    alt: title
  }) : null), React.createElement(Content, null, React.createElement(Title, null, sliceString(title, 52)), React.createElement(Description, null, sliceString(description, 128))));
};

export default CardTools;